// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { SagaObject } from '../../../SagaBase/SagaObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListLanguages_abstract extends SagaObject {
  static $t: string = 'SagaSchema.ListObjects.ListLanguages';
  $t: string = 'SagaSchema.ListObjects.ListLanguages';

  public static GetMembers(): string[] {
    return ['LanguageConst', 'DisplayValue', 'CultureString', 'Mirrored'].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListLanguages_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public LanguageConst: string;
  public DisplayValue: string;
  public CultureString: string;
  public Mirrored: boolean;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
